import React from 'react';
import Navbar from '../../components/navbar';
import FormularioNuevaEmpresa from '../../components2/formularioNuevaEmpresa';

function NuevaEmpresa () {
    return (
        <FormularioNuevaEmpresa />
    )
}

export default NuevaEmpresa;